import { IWOCA_AFFILIATE_TAG } from '../constants';

export const isPartnerAffiliateTag = (affiliateTag: string) => {
  return affiliateTag !== IWOCA_AFFILIATE_TAG;
};
